<template>
  <div class="form-section-editor">
    <table class="fse-addable-table text-center" :name="options.Key">
      <colgroup>
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 25%">
      </colgroup>
      <tbody>
        <tr class="fse-table-thead">
          <th><p class="tsw-p">标段编号</p></th>
          <th><p class="tsw-p">标段</p></th>
          <th><p class="tsw-p">详情</p></th>
          <th><el-button type="text" @click="addRow(false)">新增</el-button></th>
        </tr>
        <tr v-for="(obj, i) in rows" :key="i">
          <td>
            <p class="tsw-p">{{obj.t1852_BID_SECTION_CODE}}</p>
          </td>
          <td>
            <p class="tsw-p">{{obj.t1852_BID_SECTION_NAME}}</p>
          </td>
          <td>
            <p class="tsw-p"><el-button type="text" @click="editRow(i)">详情</el-button></p>
          </td>
          <td>
            <p class="tsw-p"><el-button type="text" @click="delRow(i)">删除</el-button></p>
          </td>
        </tr>
      </tbody>
    </table>
    <el-dialog v-model="sectionVisible" 
      top="5vh" 
      title="项目标段" 
      width="1000px" 
      custom-class="iframe-dialog dialog-sections"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <iframe :key="sectionIframe" ref="refIframe" :src="sectionIframe" class="__iframe" frameborder="0"></iframe>
      <template #footer>
        <el-button type="primary" @click="confirmEdit">确认</el-button>
        <el-button type="default" @click="closeEdit">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import formUtils from '../../../js/formUtils'
import BearInput from '~@/input/src'
import BearDatePicker from '~@/date-picker/src'
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'FormSectionEditor',
  components: {
    BearInput,
    BearDatePicker
  },
  mixins: [mixForFormItem],
  data() {
    return {
      index: 0,
      rows: [],
      sectionVisible: false,
      sectionIframe: 'about:blank'
    }
  },
  computed: {
    ...mapState(['baseInfo', 'templateAndVersion']),
    xrules() {
      let {TableColumns = []} = this.options
      const resRules = []
      TableColumns.forEach((column) => {
        let _rules = formUtils.initFormRules(column, this.form, this.param)
        this.addRefRules(_rules, column)
        resRules.push(_rules)
      })
      return resRules
    },
    requiredColumns() {
      const {length} = this.rows
      const {TableColumns = [], Total} = this.options
      const x = Total ? 1 : 0
      return length * TableColumns.filter(obj => obj.Required !== false).length + x
    },
    value() {
      let {options, form} = this
      return form[options.Key] || []
    },
    curRow() {
      return this.rows[this.index]
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(options.Value) {
          form[options.Key] = options.Value
          this.rows = options.Value
        } else {
          form[options.Key] = this.rows
          this.addRow(true)
        }
        this.$nextTick(() => {
          this.doValidate()
        })
      }).catch(() => {
        this.rows = form[options.Key] || []
        this.$nextTick(() => {
          this.doValidate()
        })
      })
    },
    addRow(first) {
      const { rows, form, options: { Key } } = this
      const lastRow = rows[rows.length - 1]
      rows.push({
        t1852_BID_SECTION_CODE: lastRow ? lastRow.t1852_BID_SECTION_CODE.replace(/\d{4}$/, n => n - -1) : `${form.t1851_TENDER_PROJECT_CODE}001`,
        t1852_BID_SECTION_NAME: ''
      })
      if (form[Key] === undefined) form[Key] = rows
      this.$nextTick(() => {
        first || this.doValidate()
      })
    },
    editRow(index) {
      const { baseInfo, templateAndVersion, rows } = this
      const { template, version } = templateAndVersion
      this.index = index
      // const 
      this.sectionIframe = `/WEB_PC/av-modules/html/common-templet/1.0.1/templet.htm?templetType=${template}&ID=${baseInfo.ID}&TENDER_PROJECT_CODE=${baseInfo.TENDER_PROJECT_CODE}&ZBGG_VERSION=${version}&isBidInit=1&r=${Math.random()}`
      this.sectionVisible = true
      this.$nextTick(() => {
        const { refIframe } = this.$refs
        refIframe.contentWindow.onload = () => {
          setTimeout(() => {
            refIframe.contentWindow.RenderData(rows[index], 'detail')
          }, 100)
        }
      })
    },
    delRow(index) {
      this.rows.splice(index, 1)
      this.$nextTick(() => {
        this.doValidate()
      })
    },
    addRefRules(_rules, column) {
    },
    confirmEdit() {
      const dataList = this.$refs.refIframe.contentWindow.SubmitData()
      if (dataList) {
        _.extend(this.curRow, dataList)
      }
      this.closeEdit()
    },
    closeEdit() {
      this.sectionIframe = 'about:blank'
      this.sectionVisible = false
    },
    getRequiredCount() {
      return this.requiredColumns
    }
  },
  watch: {
    value() {
      this.rows = this.value
      this.$nextTick(() => {
        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss">
.form-section-editor {
  .fse-addable-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    thead, .fse-table-thead {
      background: #EEF1F6;
    }
    th, td {
      padding: 10px;
      vertical-align: top;
      border: 1px solid black
    }
    .text-left {
      text-align: left;
    }
    .cat-p {
      margin: 0;
      .el-form-item {
        display: inline;
        margin-right: 0;
      }
    }
    .el-form-item--default, .el-form-item {
      .el-form-item__content {
        display: inline;
      }
    }
  }
}
.dialog-sections {
  font-family: microsoft yahei;
  .__iframe {
    height: 500px;
  }
  .el-dialog {
    &__footer {
      display: block;
      padding: 10px;
    }
  }
}
</style>
